__webpack_require__.p = "https://assets.canny.io/c177904ae60d086384cee5e6313d9f362eef4fff/";